module.exports = __webpack_public_path__ + "static/img/home_part4@2x.5d6f90e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_part4@2x.jpg
// module id = fTvD
// module chunks = 0